import * as Scrivito from "scrivito"
import { defaultPageAttributes } from "scrivito/Objs/shared/defaultAttributes"

export const KpiPageObjClass = Scrivito.provideObjClass("KpiPage", {
  attributes: {
    ...defaultPageAttributes,
    childOrder: "referencelist"
  },
  extractTextAttributes: ["body"]
})

export type KpiPageObj = InstanceType<typeof KpiPageObjClass>
